import State from '../core/State';
import { SingleCreationSetFragment } from '../generated/graphql';
import initialState from '../initialState';

export const startFetchingCreationSet = () => (state: State): State => ({
  ...state,
  creationSet: {
    ...state.creationSet,
    fetching: state.creationSet.fetching + 1,
  },
});

export const finishFetchingCreationSet = (creationSet: SingleCreationSetFragment) => (state: State): State => ({
  ...state,
  creationSet: {
    ...state.creationSet,
    creationSet,
    fetching: state.creationSet.fetching - 1,
  },
});

export const disposeCreationSetWithFetching = () => (state: State): State => ({
  ...state,
  creationSet: {
    creationSet: initialState.creationSet.creationSet,
    fetching: initialState.creationSet.fetching,
  },
});
